import angular from 'angular';
import RelatedPostsComponent from './related-posts.component';

let RelatedPostsModule = angular.module('catalog.relatedPosts', [])
  .component('relatedPosts', RelatedPostsComponent);

export default RelatedPostsModule;



// WEBPACK FOOTER //
// ./www/components/blog/related-posts/related-posts.js